/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrderShowResponse } from '../../models/order-show-response';

export interface DeleteOrderRemove$Params {
  id: string;
}

export function deleteOrderRemove(http: HttpClient, rootUrl: string, params: DeleteOrderRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderShowResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteOrderRemove.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrderShowResponse>;
    })
  );
}

deleteOrderRemove.PATH = '/v1/order/{id}';
